"use strict";

var e = require("highcharts"),
  r = require("highcharts/highstock");
require("highcharts/highcharts-more")(e), require("highcharts/modules/treemap")(e), require("highcharts/modules/treegraph")(e), require("highcharts/modules/gantt")(e), require("highcharts/modules/map")(e), require("highcharts/modules/drilldown")(e), require("highcharts/modules/solid-gauge")(e), require("highcharts/modules/sankey")(e), require("highcharts/modules/heatmap")(e), require("highcharts/modules/bullet")(e), require("highcharts/modules/wordcloud")(e), require("highcharts/modules/tilemap")(e), require("highcharts/modules/sunburst")(e), require("highcharts/modules/exporting")(e), require("highcharts/modules/export-data")(e), require("highcharts/modules/organization")(e), require("highcharts/modules/accessibility")(e), require("highcharts-grouped-categories")(e), require("highcharts/modules/arc-diagram")(e);
var h = e;
Object.defineProperty(exports, "Chart", {
  enumerable: !0,
  get: function () {
    return e.Chart;
  }
}), Object.defineProperty(exports, "setOptions", {
  enumerable: !0,
  get: function () {
    return e.setOptions;
  }
}), Object.defineProperty(exports, "createStockChart", {
  enumerable: !0,
  get: function () {
    return r.stockChart;
  }
}), exports.Highcharts = h;